import { Capacitor } from '@capacitor/core';

/**
 * Returns true when running inside a Capacitor native shell (Android / iOS).
 * On the web dev server this returns false so the getUserMedia fallback is used.
 */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/**
 * Convert a raw base64-encoded JPEG string (no `data:` prefix) into a File object.
 * Used to feed CameraPreview.capture() output into the existing compressImages pipeline.
 */
export function base64ToFile(base64: string, filename: string): File {
  const byteString = atob(base64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], filename, { type: 'image/jpeg' });
}
